import { makeAutoObservable } from "mobx";
import type { BaseStoreType } from "../common/types/BaseStoreType";
import type { MockPostM3Order } from "../mocks/handlers/generic/orders/customerOrder";
import { getProfile, type MockCustomerNumber, type MockCustomerProfile } from "../mocks/profiles";

type MockStoreType = BaseStoreType & {
   readonly isMockUser: boolean;
   readonly currentProfile: MockCustomerProfile | null;

   currentMockCustomerNumber: MockCustomerNumber | null;
   mockOrders: Record<string, MockPostM3Order>;

   setCurrentMockCustomerNumber: (mockCustomerNumbers: MockCustomerNumber | null) => void;
   addMockOrder: (orderId: string, order: MockPostM3Order) => void;
   deleteMockOrder: (orderId: string) => void;
};

const mockStore: MockStoreType = makeAutoObservable({
   currentMockCustomerNumber: null,
   mockOrders: {},
   get isMockUser() {
      return !!mockStore.currentMockCustomerNumber;
   },
   get currentProfile() {
      return mockStore.currentMockCustomerNumber ? getProfile(mockStore.currentMockCustomerNumber) : null;
   },
   setCurrentMockCustomerNumber: (mockCustomerNumber: MockCustomerNumber | null) => {
      mockStore.currentMockCustomerNumber = mockCustomerNumber;
   },
   addMockOrder: (orderId: string, order: MockPostM3Order) => {
      mockStore.mockOrders[orderId] = order;
   },
   deleteMockOrder: (orderId: string) => {
      const order = mockStore.mockOrders[orderId];
      if (order) {
         order.orderStatusLowest = "90";
         order.orderStatusHighest = "90";
      }
   },

   clearCompanySpecificData: () => {
      mockStore.mockOrders = {};
   }
} satisfies MockStoreType);

export default mockStore;
